var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            design: "v3",
            "class-name": "bulk-tags-modal",
            "show-footer": false,
            "show-title": false,
          },
          on: { cancel: _vm.onCancel },
        },
        [
          _c("div", { staticClass: "bulk-tags-modal-content" }, [
            _c("div", { staticClass: "modal-section" }, [
              _c("div", { staticClass: "selection-wrapper" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("local_offer"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Etiket Seçimi")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("label", { staticClass: "field-label" }, [
                      _vm._v("Etiketler"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticClass: "tags-select",
                        attrs: {
                          mode: "multiple",
                          size: "large",
                          placeholder: "Etiket seçin...",
                          "filter-option": _vm.filterOption,
                          "show-search": "",
                        },
                        model: {
                          value: _vm.selectedTags,
                          callback: function ($$v) {
                            _vm.selectedTags = $$v
                          },
                          expression: "selectedTags",
                        },
                      },
                      _vm._l(_vm.availableTags, function (tag) {
                        return _c(
                          "a-select-option",
                          { key: tag._id, attrs: { value: tag._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(tag.name) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-hint" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("lightbulb_outline"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Birden fazla etiket seçebilirsiniz"),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.selectedTags.length > 0
                ? _c("div", { staticClass: "preview-section" }, [
                    _c("div", { staticClass: "preview-header" }, [
                      _c("div", { staticClass: "header-left" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("sell"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("Seçilen Etiketler")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "count-badge" }, [
                        _vm._v(_vm._s(_vm.selectedTags.length)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tags-wrapper" },
                      _vm._l(_vm.selectedTags, function (tagId) {
                        return _c(
                          "div",
                          { key: tagId, staticClass: "tag-chip" },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("label"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.getTagName(tagId)))]),
                            _vm._v(" "),
                            _c("div", { staticClass: "tag-check" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("check"),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("SupsisButton", { on: { click: _vm.onCancel } }, [
                  _vm._v("İptal"),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { attrs: { primary: "" }, on: { click: _vm.onConfirm } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("label"),
                    ]),
                    _vm._v("\n                Etiket Ekle\n            "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }